<template>
  <transition name="fade">
    <div v-if="visible" class="dialog-mask" @click.self="handleClose">
      <transition name="zoom">
        <div class="dialog-box" v-show="visible" :style="{ width, borderRadius }">
          <div class="dialog-content">
            <div class="area">
              <div class="title">上传营业执照</div>
              <a
                style="position: relative;width: 100%;height: 150px;margin-top: 8px;margin-bottom: 10px">
                <Upload :action="uploadFile" name="file" :on-success="uploadCallback"
                        :data="uploadData" accept="image/*" :show-upload-list="false">
                  <img :src="params.licenseUrl" class="bg1"></img>
                  <div class="bg2" v-if="params.licenseUrl.startsWith('https://www.mgadmob.com/mp/icon/addLicenseBg.png')">
                    <img src="https://www.mgadmob.com/mp/icon/addLicense.png" style="width: 26px;height: 26px;">
                    </img>
                    <div style="margin-top: 5px;color: black;font-size: 14px">上传营业执照正面</div>
                  </div>
                </Upload>
              </a>
              <div class="title">个人信息</div>
              <Input class="search-style" v-model="params.name" placeholder="请输入姓名" clearable/>
              <Input class="search-style" v-model="params.idCard" placeholder="请输入身份证号" clearable style="margin-top: 8px"/>
              <div class="title" style="margin-top: 10px">公司名称</div>
              <Input class="search-style" v-model="params.company" placeholder="请输入公司名称" clearable/>
            </div>
          </div>

          <!-- 底部按钮 -->
          <a
            class="btn confirm"
            @click="submit"
          >{{ confirmText }}
          </a>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import api from "@/api";

export default {
  name: 'AddLicenseDialog',
  props: {
    visible: {type: Boolean, default: false},
    showConfirm: {type: Boolean, default: true},
    confirmText: {type: String, default: '确定'},
    width: {type: String, default: '360px'},
    borderRadius: {type: String, default: '14px'},
  },
  data() {
    return {
      selectedJob: null,
      citySelect: null,
      address: null,
      jobDesc: null,
      params: {
        licenseUrl: 'https://www.mgadmob.com/mp/icon/addLicenseBg.png',
        idCard: null,
        name: null,
        company: null,
      },
      uploadFile: api.statistics.uploadFileToc,
      uploadData: {filePath: 'img'},
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    uploadCallback(response, file, fileList) {
      if (response.code == 2000) {
        this.params.licenseUrl = response.data
      }
    },
    submit() {
      if (!this.params.licenseUrl.startsWith("http") || this.params.licenseUrl.startsWith('https://www.mgadmob.com/mp/icon/addLicenseBg.png')) {
        this.$Message.error('营业执照未上传，请选择上传')
        return
      }
      if (this.params.name == null) {
        this.$Message.error('请填写姓名')
        return
      }
      if (!this.util.checkChineseName(this.params.name)) {
        this.$Message.error('姓名格式有误，请重填写')
        return;
      }
      if (this.params.idCard == null) {
        this.$Message.error('请填写身份证号')
        return
      }
      if (!this.util.isIDCard18Exact(this.params.idCard)) {
        this.$Message.error('身份账号格式有误，请重填写')
        return
      }
      if (this.params.company == null) {
        this.$Message.error('请填写公司名称')
        return
      }
      api.statistics
        .saveCompanyInfo(this.params)
        .then(res => {
          if (res.code == 2000) {
            this.$emit('confirm', {
              licenseUrl: this.params.licenseUrl,
              idCard: this.params.idCard,
              name: this.params.name,
              company: this.params.company,
              companyId: res.data
            })
            this.handleClose()
          } else {
            this.$Message.error('保存失败，请稍后重试')
          }
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
  }
}
</script>

<style scoped>
/* 遮罩层，百分百占满视口，高度必须 100vh */
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 弹窗主体 */
.dialog-box {
  background: #fff;
  max-width: 80vw;
  width: auto;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  text-align: center;
  /* 💡 防止动画偏移 */
  transform-origin: center;
  padding: 22px 18px;
}

.dialog-content {
  display: flex;
  flex-direction: column;
}

.area {
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
  border-radius: 25px;
}

.search-style {
  font-size: 16px;
}

.title {
  font-size: 16px;
  color: black;
  margin-bottom: 10px;
  text-align: left;
  font-weight: bold;
}

.bg1 {
  width: 100%;
  height: 150px;
  object-fit: contain;
}

.bg2 {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* 居中 */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* ✅ 按钮区域 */
.dialog-actions {
  display: flex;
  justify-content: space-around;
  margin-top: 12px;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
  padding: 0 24px;
  border: none;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn.confirm {
  background: #26B399;
  margin: 10px 0px 0px 0px;
  color: white;
}
</style>
